import U from '../../common/ticket_stub/ticket_stub_utils';
import get from 'lodash/get';

const getLevel = (unassignedSeat, areaNames) => {
  const idArray = get(unassignedSeat, 'id', '').split('-');
  const level = get(idArray, '[0]', '');

  return get(areaNames, `levels[${level}]`, '');
};

const getSection = (unassignedSeat, areaNames) => {
  const idArray = get(unassignedSeat, 'id', '').split('-');
  const section = get(idArray, '[1]', '');

  return get(areaNames, `sections[${section}]`, '');
};

const unassignedSeatToTicket = (unassignedSeat, areaNames) => {
  if (!unassignedSeat || !areaNames) return {};

  const tmp = {
    seat_name: {}
  };
  tmp.seat_name[U.LEVEL] = getLevel(unassignedSeat, areaNames);
  tmp.seat_name[U.SECTION] = getSection(unassignedSeat, areaNames);
  tmp.seat_name[U.ROW] =  get(unassignedSeat, 'row', '');
  tmp.seat_name[U.SEAT] =  get(unassignedSeat, 'seat', '');

  return tmp;
};

export default  {
  unassignedSeatToTicket: unassignedSeatToTicket
};



// WEBPACK FOOTER //
// ./frontend/react/components/edp/pricetypeselector/pricetype_selector_utils.js